import type { InfoHintDetail } from '@cou/admin-ui';
import type { AdminAward } from './awards-client';

/**
 * The rows behind an Award row's single ⓘ, on the first column.
 *
 * One hint per record: the Award, the User and the Contest ids all belong to this one row, so
 * they live in one place rather than an icon per column.
 *
 * The Award's own id leads because it is the only one the row shows nowhere — it is what an
 * operator quotes when chasing a delivery that never landed. Everything the row already displays
 * (tier, reward, state, attempts, last error) is deliberately absent: repeating a visible column
 * is noise, not detail.
 */
export function awardDetails(
  award: Pick<AdminAward, 'id' | 'userId' | 'account' | 'contestId'>,
  contestName?: string,
): InfoHintDetail[] {
  const rows: InfoHintDetail[] = [
    { label: 'Award ID', value: award.id, copyable: true },
    { label: 'Account', value: award.account, copyable: true },
    { label: 'Player ID', value: award.userId, copyable: true },
  ];
  // API-23 carries contestName on the Award row; absent or blank means the id alone carries it.
  if (contestName !== undefined) rows.push({ label: 'Contest', value: contestName });
  rows.push({ label: 'Contest ID', value: award.contestId, copyable: true });
  return rows;
}
